import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpService } from 'src/app/shared/services/http.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit, AfterViewInit {

  public show: boolean = false;
  public registerForm: FormGroup;
  public loginForm: FormGroup;
  showPassword: boolean = false;


  @ViewChild('container') container!: ElementRef;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: HttpService
  ) {
    // Initialize register form
    this.registerForm = this.fb.group({
      name: ['', [Validators.required]],
      user_name: ['', [Validators.required]],
      company_name: ['', [Validators.required]],
      country: ['', [Validators.required]],
      referenced_by: ['', [Validators.required]],
      currency: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      contact_no: ['', [Validators.required, this.phoneValidator]],
      password: ['', [Validators.required]],
      type: ['user', [Validators.required]],
    });

    

    // Initialize login form
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      type: ['user', [Validators.required]],
    });
  }

  ngOnInit() {
    // This logic will be moved to ngAfterViewInit
  }

  ngAfterViewInit() {
    const signUpButton = document.getElementById('signUp');
    const signInButton = document.getElementById('signIn');

    if (signUpButton && signInButton) {
      signUpButton.addEventListener('click', () => {
        this.container.nativeElement.classList.add("right-panel-active");
      });

      signInButton.addEventListener('click', () => {
        this.container.nativeElement.classList.remove("right-panel-active");
      });
    }
  }

  // Custom validator to check if passwords match
  passwordMatchValidator(form: FormGroup) {
    return form.get('password')?.value === form.get('confirmPassword')?.value
      ? null : { 'passwordMismatch': true };
  }



  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  phoneValidator(control: any) {
    const value = control.value;
    if (value && value.e164Number) {
      return null; // Valid phone number
    }
    return { invalidPhone: true }; // Invalid phone number
  }
  

  onSubmit() {
    if (this.registerForm.valid) {
      const contactNumberControl = this.registerForm.get('contact_no');
      if (contactNumberControl) {
        const intlTelInputData = contactNumberControl.value; // Get the object from ngx-intl-tel-input
        const pureNumber = intlTelInputData.number; // Extract the 'number' field (e.g., '617-397-9113')
        this.registerForm.patchValue({ contact_no: pureNumber });
      }
  
      this.singUp();
    } else {
      console.log('Form is invalid');
    }
  }

  singUp() {
    this.http.post('signup', this.registerForm.value, true).subscribe(
      (res: any) => {
        console.log("Registration successful", res);
        this.switchToLogin(); // Switch to login after successful registration
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  switchToLogin() {
    this.container.nativeElement.classList.remove("right-panel-active");
  }


  login() {
    if (this.loginForm.valid) {
      this.http.post('login', this.loginForm.value, false).subscribe((res: any) => {
        console.log(res, "helloresss");
  
        localStorage.setItem('token', JSON.stringify(res?.token));
        localStorage.setItem('user', JSON.stringify(res?.user));
  
        this.router.navigate(['/dashboard/default']);
      }, (err: any) => {
        console.error('Login failed', err);
      });
    } else {
      console.log('Login form is invalid');
    }
  }
}
